import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams, } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import { config } from "assets/common/dynamicConfig";
import Layout from "components/Layout";
import DynamicForm from "components/DynamicForm";
import Recursive from "components/Recursive";

import {
  clearSelectedData,
  clearSelectedDataKey,
  clearValidateTriggered,
  setSelectedData,
} from "redux/formDisplay";
import {
  setIsMinor,
  clearSaveData,
  clearShowData,
  clearRecursiveFormData,
  setEditIndex,
} from "redux/recursiveReducer";
import {
  setApplicantUser,
  setPrimaryUser,
  setworkflowUser,
} from "redux/userInfo";
import conditionalRendering, {
  incrementActiveStepOrder,
  setActiveStepOrder,
} from "redux/conditionalRendering";
import {
  setRecursiveFormData,
  setShowRecursiveForm,
  setShowAddMore,
  setIsEditRecursiveForm,
} from "redux/recursiveReducer";
import { getWorkflowData, updatePrimaryWorkflow } from "api/formDisplay";
import {
  checkLinkForExpiryBasedOnID,
  getConfiguration,
} from "api/configuration";
import { Group } from "lib";
import FormButton from "components/FormButton";
import { validate } from "components/DynamicForm/validate";
import { dynamicFormScroll } from "utils";
import Consent from "components/Consent";
import {
  setSections,
  setStepperDisplay,
  setBanner,
  setNavOrientation,
  setFormOccupancy,
} from "redux/stepperReducer";
import LoadingSpinner from "lib/LoadingSpinner";
import moment from "moment";
import { setIsInternal } from "redux/usersReducer";
import { encryptUrl } from "api/UrlEncryption";
import { setConfigLoading } from "redux/configurationReducer";
import { getRolesInfo } from "api/user";
import { GenericModal } from "components/PopupComp";
import { processUaePassData } from "api/uae-pass";
import { encrypt } from "helper/encryptDecrypt";
import { initiateUaePassAuth } from "api/uae-pass";
import { UAE_PASS_ROUTE } from "constants/routes";

const WorkflowVerification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { redirectionConfigId } = useParams();
  const userParams = useParams();

  const [isUaePassDataProcessing, setIsUaePassDataProcessing] = useState(false);
 
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const dataPreview = useSelector((state) => state.recursive?.showDataPreview);
  const activeStepOrder = useSelector(
    (state) => state.conditionalRendering?.activeStepOrder
  );
  // console.log("active activeStepOrder", activeStepOrder)
  // const userToken =
  // localStorage.getItem("userToken") &&
  // JSON.parse(localStorage.getItem("userToken"));

  const sub_id = useSelector((state) => state.userInfo?.subId);

  const consentsConfig = useSelector(
    (state) => state?.consentReducer?.consentConfig?._id
  );
  const consentText = useSelector(
    (state) => state?.consentReducer?.consentText
  );
  const consentType = useSelector(
    (state) => state?.consentReducer?.consentConfig?.service_name
  );

  const config = useSelector((state) => state.configurationReducer?.config);
  const dynamic_wf = config?.dynamic_wf;

  const loading = useSelector((state) => state.configurationReducer?.loading);
  const showRecursiveForm = useSelector(
    (state) => state.recursive.showRecursiveForm
  );
  const recursiveFormData = useSelector(
    (state) => state.recursive?.recursiveFormData
  );
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const isMinor = useSelector((state) => state.recursive.isMinor);
  const is_uae_pass_verified = useSelector((state)=> state?.userInfo?.primaryUser?.source_data?.is_uae_pass_verified);
  const uae_pass_linking_type  = useSelector((state)=> state?.userInfo?.primaryUser?.source_data?.uae_pass_linking_type);
  // const config = useSelector(

  //   (state) => state.configurationReducer?.config
  // );
  //recursion rework
  
  const applicantUser = useSelector((state) => state.userInfo?.applicantUser);
  
  const activeSection = useSelector((state) => state.userInfo.activeSection);
  const userInfoLoading = useSelector((state) => state.userInfo.loading);
  const stepperSections = useSelector(
    (state) => state?.stepperReducer?.sections
  );
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const staticData = useSelector((state) => state?.staticData);
  const currentStep = useSelector((state) =>
    state.stepperReducer?.sections[1]?.form_groups.find(
      (group) => group.group_order === activeStepOrder

      // (group) => {
      //   return eval(group?.show)
      // }
    )
  );
  // console.log("🚀 ~ worfk verifi currentStep:", currentStep)
  if(Object.keys(loggedInUserInfo).length !== 0 && stepperSections){
    let tempOrder = stepperSections[1]?.form_groups.find(
      (group) => group.name === "preview_data"
    );
    dispatch(setActiveStepOrder(tempOrder?.group_order));
  }else if(Object.keys(loggedInUserInfo).length === 0 && stepperSections && currentStep){
    let tempOrder = stepperSections[1]?.form_groups.find(
      (group) => {
        return eval(group?.show)
      }
    )
    dispatch(setActiveStepOrder(currentStep?.group_order));

  }



  
  const userInitatedRequired = useSelector(
    (state) => state.conditionalRendering?.userInitatedRequired
  );
  const navOrientation = useSelector(
    (state) => state.stepperReducer.navOrientation
  );
  const organisation_id = config?.organisation_id;
  const isAPILoadingForLinkExpiryValidation = useSelector((state) => state?.conditionalRendering?.isAPILoadingForLinkExpiryValidation)

  let formSkeleton = {},
    sections = {},
    finalPayload,
    fields,
    banner = {};
  // const [conditionalSection, setConditionalSection] = useState({});
  const [formErr, setFormErr] = useState({});

  //Mobile Responsivess state
  const [isMobile, setIsMobile] = useState(false);
  const [isCreateWorkFlowLoading, setIsCreateWorkFlowLoading] = useState(false);

  const stateErrRef = useRef();
  const selectedDataRef = useRef();

  stateErrRef.current = { ...formErr };
  selectedDataRef.current = { ...selectedData };

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };


  const search = window.location.search;
  const query = new URLSearchParams(search);
  const queryPath = query.get("physical_form");

  const authType = useMemo(() => {
    return query.get("authType")
  }, [query]);

  const declaration = useMemo(() => {
    return query.get("declaration");
  }, [query]);

  const fetchData = async () => {
    if (
      decryptedId?.primaryWorkflowId &&
      decryptedId?.userId &&
      (!Object.keys(primaryUser).length || !Object.keys(applicantUser).length)
    ) {
      let response = await getWorkflowData(decryptedId?.primaryWorkflowId);
      dispatch(getConfiguration(response?.configuration_id));
      if (response) {
        dispatch(setPrimaryUser(response));
        if (
          response?.active_step !== 1 &&
          Object.keys(loggedInUserInfo).length === 0 &&
          !isAPILoadingForLinkExpiryValidation && !declaration
        )
        navigate("/update-successful");
        let subworkflowsObj = response?.source_data?.subworkflows?.find(
          (item) => item.user_id == decryptedId?.userId
        );
        if (subworkflowsObj) {
          let res = subworkflowsObj?._id === decryptedId.primaryWorkflowId ? response :  await getWorkflowData(subworkflowsObj?._id);
          if (
            res?.active_step !== 1 &&
            Object.keys(loggedInUserInfo).length === 0 &&
            !isAPILoadingForLinkExpiryValidation && !declaration
          ) {
            navigate("/update-successful");
          }
        }
        if (
          !config?.wf_journey?.find(
            (item) => item.module_name === "Dynamic Forms"
          )
        ) {
          dispatch(getConfiguration(response?.configuration_id));
        }
        (!applicantUser || !Object.keys(applicantUser).length) &&
          dispatch(setApplicantUser(subworkflowsObj));
        if (subworkflowsObj?.active_step) {
          // if (loggedUserId) {
          //   dispatch(setActiveStepOrder(3));
          // } 
          // else{
        
          if((response?.source_data?.uae_pass_linking_type != "manual") && (authType?.toLowerCase() === "uaepass"|| authType?.toLowerCase() == "uaepasslogin") ){
            dispatch(setActiveStepOrder(subworkflowsObj?.active_step + 1));
          }else{
            dispatch(setActiveStepOrder(subworkflowsObj?.active_step));
          }
          // }
        }
      }
    }
  };

  /**
   ** This function takes the workflowId and calls the uae pass data processing API
   ** and then calls the fetchData() again to fetch the updated workflow data
   * @param {*} workflowId 
   */
  const startDataProcessing = async (workflowId) => {
    try {
      setIsUaePassDataProcessing(true);

      const result = await processUaePassData({
        _id: workflowId,
      });

      const {status,message} = result;
      if(status?.toLowerCase() === "failed") {
        if(message.includes('user Cancelled login.')){
          toast.error('User cancelled the login');
        // * Redirecting the user after 4 secs to allow them to read the Toast message
        setTimeout(() => {
          window.location.href = result?.data?.uaePassInitiationLink;
        }, 5000);
        }else{
          if(message){
            toast.error(message);
          }else{
            toast.error('Invalid Credentials');
          }
          const navigationLink = result?.data?.uaePassInitiationLink;          
          if (navigationLink) {
            setTimeout(() => {
              window.location.href = `${UAE_PASS_ROUTE}/logout?redirect_url=${navigationLink}`;
            }, 5000);
        }
      }
      
      } else {
        fetchData();
        setIsUaePassDataProcessing(false);
      }      
    } catch (err) {
      console.log(err);
    }
  };

   /**
   ** This function initiates the Authentication process with UAE Pass
   ** To use this function use the button action as {uae_pass_auth} in the config
   */
   const handleUaePassAuth = async (fieldName, trigger) => {
    try {
      /**
       ** First calling the handleNext() function to save the entered details and
       ** then will initiate the UAE Pass auth process.
       */
      // const applicantData = await handleNext(fieldName, trigger, true);

      const origin = window.location.origin;
      // const redirectionUrl = `${origin}/unified${applicantData.link}`
      const response = await initiateUaePassAuth({
        reference_id   : "xxxx",
        callback_url : "https://in-unified.qa-signdesk.com/api/uae-pass/authCallback",
        //* Once the UAE Pass auth is successful then the user will be redirected to this url
        redirection_url: window.location.href,
        is_uae_pass_verified : is_uae_pass_verified,
        workflow_id : primaryUser?._id
      });

      // * If we the UAE pass auth is successfully initiated
      if(response?.status.toLowerCase() === "success") {
        const authenticationUrl = response.data?.authentication_url;
        if(!authenticationUrl) throw new Error("Authentication URL is not found!");

        // * Navigating the user to the UAE Pass authentication URL
        window.location.replace(authenticationUrl);
      }

    } catch (err) {
      console.log(err);
    }
  }


  useEffect(() => {
    if((authType?.toLowerCase() === "uaepass" || authType?.toLowerCase() == "uaepasslogin") &&  decryptedId?.primaryWorkflowId && decryptedId?.userId) {
      startDataProcessing(decryptedId?.primaryWorkflowId)
    }
  }, [authType, decryptedId])

  useEffect(() => {
    if(authType?.toLowerCase() !== "uaepass" || authType?.toLowerCase() == "uaepasslogin") {
      if (!config?.wf_journey?.find(item => (item.module_name === 'Dynamic Forms'))) {
        dispatch(setConfigLoading(true));
      }
      fetchData();
    }
    
  }, [decryptedId]);

  useEffect(() => {
    let configSections = [];
    let formStructure = [];
    let module_access;
    let userToken = JSON.parse(localStorage.getItem("userToken"));
    config?.wf_journey?.map((item) => {
      if (item?.type === "default") {
        formStructure = { ...item?.form_structure };
      }
    });
    // Role based access for form innitiation starts
    if(userToken && userToken?.role && module_access) {
      let query_params = {
        role_id: userToken?.role,
        organisation_id: organisation_id
      };
      dispatch(setConfigLoading(true))
      dispatch(getRolesInfo(query_params))
      .unwrap()
      .then((result) => {
        if(result) {
          let module_info = result?.module_list.filter((item) => item.module_id == module_access);
          if(module_info.length && !(module_info[0].add && module_info[0].edit)) navigate("/error")
          else dispatch(setConfigLoading(false))
        } else dispatch(setConfigLoading(false))
      })
    }

    // Role based access for form initiation ends
    banner = formStructure?.sections?.filter((item) => item?.type === "banner");
    configSections = formStructure?.sections?.filter(
      (item) => item?.type !== "banner"
    );
    // console.log("🚀 ~ configSections?.forEach ~ configSections:", configSections)
    configSections?.forEach((item, index) => {
      sections[item?.order] = {
        title: item?.title,
        name: item?.name,
        show: item?.show,
        type:item?.type,
        form_groups: item?.form_groups?.map((_item, _index) => {
          return {
            name: _item?.name,
            title: _item?.title,
            group_order: _item?.order,
            display_group: _item?.show,
            group_length: _item?.form_groups?.length,
            show: _item?.show,
            next_step: _item?.next_step,
            form_elements: _item?.form_elements,
            form_buttons: _item?.form_buttons,
          };
        }),
        section_order: item?.order,
        element_number: index,
        display_section: item?.show,
      };
    });
    dispatch(setBanner(banner));
    dispatch(setSections(sections));
    dispatch(setNavOrientation(formStructure.nav_orientation));
    dispatch(setFormOccupancy(formStructure.form_occupancy));
    if (formStructure.layout === "regular") dispatch(setStepperDisplay(false));
    else dispatch(setStepperDisplay(true));
  }, [config]);

  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width < 640 && !isMobile) {
      setIsMobile(true);
    } else if (width > 640 && isMobile) {
      setIsMobile(false);
    }
  };

  window.addEventListener("resize", () => checkWindowWidth());

  // Mobile Responsivess - conditions - end
  useEffect(() => {
    checkWindowWidth();
  }, []);

  const handleRedirect = async (link) => {
    const splitLink = link.split("/");
    const primaryWfId = await encryptUrl(splitLink[2]);
    const userId = await encryptUrl(splitLink[3]);
    const redirectLink = `/${splitLink[1]}/${primaryWfId}/${userId}`;
    navigate(link);
  };
  // let userToken = localStorage.getItem("userToken");
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  let loggedInUserName = loggedUserId
    ? `${
        (loggedInUserInfo?.profileInfo?.first_name || "") +
        " " +
        (loggedInUserInfo?.profileInfo?.last_name || "")
      }`
    : "";
  let loggedInUserEmail =
    loggedUserId && loggedInUserInfo?.profileInfo?.emailId;
  let loggedInUserMobileNumber =
    loggedUserId && loggedInUserInfo?.profileInfo?.mobileNumber;

  const handleNext = async (params) => {
    let payload = { ...selectedData };
    if (currentStep.name === "applicant_consent") {
      let primarydata = JSON.parse(JSON.stringify(primaryUser));
      primarydata.userId = decryptedId?.primaryWorkflowId;
      primarydata.activeUser = decryptedId?.userId;
      delete primarydata._id;
      let data = primarydata?.source_data?.subworkflows?.map((item) => {
        if (item.user_id == decryptedId?.userId) {
          return {
            ...item,
            is_consent_approved: true,
            active_step: activeStepOrder,
            consents_approved: [
              {
                consent_type: consentType,
                consents_id: consentsConfig,
                consent_text: consentText,
                approved_at: moment(new Date()),
              },
            ],
          };
        } else {
          return {
            ...item,
          };
        }
      });
      primarydata.source_data.subworkflows = [...data];
      dispatch(updatePrimaryWorkflow(primarydata));
    }

    if (currentStep.name === "otp_verification") {
      let result = await getWorkflowData(decryptedId?.primaryWorkflowId);
      dispatch(setPrimaryUser(result))
      let primarydata = JSON.parse(JSON.stringify(result));
      // delete primarydata._id;
      primarydata.userId = decryptedId?.primaryWorkflowId;
      let data = primarydata?.source_data?.subworkflows?.map((item) => {
        if (item.user_id == decryptedId?.userId || primarydata?.source_data?.subworkflows?.some((subworkflow) =>
          subworkflow?.email === item?.email && subworkflow?.is_verified === "false"
        )) {
          return {
            ...item,
            status: "In draft",
            is_verified: true,
            active_step: currentStep?.group_order,
          };
        }
        return item;
      });
      if (data.every((item) => {return item?.is_verified === true}) && primarydata.status == 'Verification Pending') {
        primarydata.status = "In draft"
      }
      primarydata.source_data.subworkflows = [...data];
      // dispatch(incrementActiveStepOrder())
      let primarydata1 = JSON.parse(JSON.stringify(primarydata));
      primarydata1.activeUser = decryptedId?.userId;
      delete primarydata1._id;
      dispatch(setPrimaryUser(primarydata));
      if(applicantUser?.is_verified === false){
        dispatch(updatePrimaryWorkflow(primarydata1));
      }
      dispatch(setIsInternal(true));
      if (
        primarydata?.created_by !== null &&
        applicantUser?.is_verified === false
      ) {
        const stateData = {
          content_trigger: params?.content_trigger,
            organisation_id:organisation_id
        };
        let encryptedData =  await encrypt(stateData)
          sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
          navigate("/update-successful");
       
      }
    }

    if (currentStep.name === "whatsapp_otp_verification") {
      let primarydata = JSON.parse(JSON.stringify(primaryUser));
      delete primarydata._id;
      primarydata.userId = decryptedId?.primaryWorkflowId;
      let data = primarydata?.source_data?.subworkflows?.map((item) => {
        if (item.user_id == decryptedId?.userId) {
          return {
            ...item,
            status: "In draft",
            is_mobile_verified: true,
            active_step: activeStepOrder,
          };
        }
        return item;
      });

      primarydata.source_data.subworkflows = [...data];
      dispatch(incrementActiveStepOrder());
      let primarydata1 = JSON.parse(JSON.stringify(primarydata));
      primarydata1.activeUser = decryptedId?.userId;
      dispatch(setPrimaryUser(primarydata));
      dispatch(updatePrimaryWorkflow(primarydata1));
      dispatch(setIsInternal(true));
      if (
        primarydata?.created_by !== null &&
        applicantUser?.is_verified === false
      ) {
        const stateData = {
          content_trigger: params?.content_trigger,
            organisation_id:organisation_id
        };
        let encryptedData =  await encrypt(stateData)
        sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
        navigate("/update-successful");
      }
      dispatch(incrementActiveStepOrder(currentStep.next_step));
    }

    dispatch(clearValidateTriggered());
    dispatch(incrementActiveStepOrder(currentStep.next_step));
  };

  const handleSkip = () => {
    dispatch(clearValidateTriggered());
    dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step)));
  };

  const handleSkipOtp = () => {
    dispatch(clearValidateTriggered());
    dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step) + 1));
  };

  const handleCancel = () => {
    dispatch(setShowAddMore(true));
    showRecursiveForm && dispatch(setShowRecursiveForm(false));
    !showRecursiveForm && dispatch(clearRecursiveFormData());
    dispatch(setIsEditRecursiveForm(false));
    dispatch(setEditIndex(-1));
    isMinor && dispatch(setIsMinor(false));
  };

  const handleBack = () => {
    setFormErr({});
    dispatch(clearValidateTriggered());
    dispatch(clearSaveData());
    dispatch(clearShowData());
    dispatch(setActiveStepOrder(activeStepOrder - 1));
    dynamicFormScroll();
  };

  const validateAndSubmit =async (
    action,
    params
  
  ) => {
    let validateFields = [];
    fields.map((item) => {
      if (
        item.type == "group" ||
        item.type == "recursive" ||
        item.type == "questionnaire"
      ) {
        let selectToggleFields = false;
        item.input_fields?.map((_item) => {
          if (_item.type == "toggle") {
            selectToggleFields = true;
          }
          if (
            selectToggleFields &&
            _item.hasOwnProperty("show") &&
            IndirectEval(item.show)
          ) {
            validateFields = [...validateFields, _item];
          }
          if (!selectToggleFields) {
            let selectDependentFields = true;
            if (_item.hasOwnProperty("show")) {
              selectDependentFields = IndirectEval(_item.show);
            }
            if (selectDependentFields)
              validateFields = [...validateFields, _item];
          }
        });
      } else {
        let fieldVisiblity = false;
        if (item.hasOwnProperty("show"))
          fieldVisiblity = IndirectEval(item?.show);
        else fieldVisiblity = true;
        if (fieldVisiblity) {
          validateFields = [...validateFields, item];
        } else {
          dispatch(clearSelectedDataKey({ key: item.name }));
        }
      }
    });

    let errors;
    if (params?.isRecursive) {
      errors = await validate(
        validateFields,
        recursiveFormData,
        dispatch,
        staticData
      );
    } else {
      if (dataPreview && !showRecursiveForm) {
        errors = {};
      } else {
        errors =await validate(validateFields, selectedData, dispatch, staticData);
      }
    }

    let errKeys = Object.keys(errors);
    if (errKeys?.length === 0) {
      switch (action) {
        case "next":
          handleNext(params);
          break;
        //* MOVE handleEdit also here to avoid having same validation code inside recursion
        default:
          break;
      }
      return;
    } else {
      setFormErr(errors);
      dynamicFormScroll();
    }
  };

  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...stateErrRef?.current };

    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }

    setFormErr(err);
  };

  const switchingProfile = async (
    primaryWorkflowId,
    userId,
    subWfId,
    is_verified
  ) => {
    dispatch(setConfigLoading(true));
    const sourceData = primaryUser?.source_data;

    const primary_workflow_id = await encryptUrl(
      primaryWorkflowId ? primaryWorkflowId : subWfId
    );
    const user_id = await encryptUrl(loggedUserId ? loggedUserId : userId);
    const sub_workflow_id = await encryptUrl(subWfId);
    const subId = await encryptUrl(
      loggedUserId ? loggedUserId : decryptedId?.userId
    );
    if (is_verified) {
     
      if (userId == sub_id) {
        sourceData.subworkflows.forEach((element) => {
          if (subWfId == element._id) {
            dispatch(setworkflowUser({ ...sourceData, subworkflows: element }));
          }
        });
        if (dynamic_wf) {
          navigate(
            `/formSubmission/dynamicworkflow/${primary_workflow_id}/${user_id}/${sub_workflow_id}${
              (loggedUserId && "?userInitiated=true") || ""
            }`
          );
        } else {
          navigate(
            `/formSubmission/${primary_workflow_id}/${user_id}/${sub_workflow_id}${
              (loggedUserId && "?userInitiated=true") || ""
            }`
          );
        }
        dispatch(clearSelectedData());
      } else {
        primaryUser?.source_data?.subworkflows?.map(async (item) => {
          if (userId == item?.user_id) {
            dispatch(setworkflowUser({ ...sourceData, subworkflows: item }));
            const _id = await encryptUrl(item?._id);
            if (dynamic_wf) {
              navigate(
                `/formSubmission/dynamicworkflow/${primary_workflow_id}/${subId}/${_id}${
                  (loggedUserId && "?userInitiated=true") || ""
                }`
              );
            } else {
              navigate(
                `/formSubmission/${primary_workflow_id}/${subId}/${_id}${
                  (loggedUserId && "?userInitiated=true") || ""
                }`
              );
            }
            dispatch(clearSelectedData());
          }
        });
      }
    }
  };

  // console.log("🚀 ~ stepperSections:", stepperSections)
  if(stepperSections[1]?.type == "workflow_verification" && stepperSections[1]?.show == false){
    switchingProfile(decryptedId?.primaryWorkflowId,decryptedId?.userId,decryptedId?.primaryWorkflowId,true)
  }
  

  const populateStepper = (_item) => {
    let updatedSections = {
      1: {
        title: stepperSections[1]?.title,
        section_order: 1,
        element_number: 0,
        display_section: true,
        form_groups: stepperSections[1]?.form_groups?.map((item, index) => {
          return {
            ...item,
            form_elements: item?.form_elements?.map((_item, index) => {
              if (_item.type === "consent") {
                // console.log(_item);
                return {
                  ..._item,
                  title: _item.title,
                  type: "singleConsent",
                };
              }
              return {
                ..._item,
              };
            }),
          };
        }),
      },
    };
    dispatch(setSections(updatedSections));
  };

  /**
   ** Intermediate step via Modal Once the user is being redirected back to 
   ** dynamic forms from UAE Pass's website 
   */

   if (isUaePassDataProcessing) {
     return (
       <>
         <GenericModal show={true} onClose={() => {}} size={300}>
           <p
             style={{
               // * This is temp styling will be remove soon
               minHeight: "10rem",
               textAlign: "center",
               margin: "auto",
               alignItems: "center",
               display: "flex",
             }}
           >
             <>
               <ToastContainer style={{ zIndex: "9999 !important" , textAlign: "left"}} />
               Please Wait, we are processing the data ......
             </>
           </p>
         </GenericModal>
       </>
     );
   }

  //spinnner to load ddf
  if (loading || userInfoLoading || isCreateWorkFlowLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Layout landing={true} nav_orientation={navOrientation}>
      {Object.entries(stepperSections)?.map((section, index) => {
        index = parseInt(section[0]);
        section = section[1];
        const { section_order, is_last_section, redirect_url } = section;
        if (section_order === activeSection) {
          return section?.form_groups?.map((item, index) => {
            // console.log("🚀 ~ {Object.entries ~ section_order:", item.group_order, activeStepOrder)
            if (Number(item.group_order) == activeStepOrder) {
              if (eval(item.show)) {
                fields = item?.form_elements;
                return (
                  <Fragment key={index}>
                    {fields?.map((_item, _index) => {
                      if (_item.type === "recursive") {
                        return (
                          <Fragment key={_index}>
                            <Recursive
                              inputFields={_item.input_fields}
                              handleNext={validateAndSubmit}
                              handleCancel={handleCancel}
                              selectedData={recursiveFormData}
                              setSelectedData={setRecursiveFormData}
                              recursiveActions={_item.recursive_actions}
                              dataPreview={dataPreview}
                              clearFieldError={clearFieldError}
                              formErr={formErr}
                              setFormErr={setFormErr}
                              recursiveTitle={_item.recursive_title}
                              minLength={_item.min_length}
                              maxLength={_item.max_length}
                              customStyle={_item.custom_styles}
                            />
                          </Fragment>
                        );
                      }
                      if (_item.type === "consent") {
                        populateStepper(_item);
                        return;
                      }

                      if (_item.type === "singleConsent") {
                        return (
                          <Fragment key={index}>
                            <Consent
                              consentName={_item.name}
                              layout={_item.layout}
                              consent={_item.consents[0]}
                              setSelectedData={setSelectedData}
                            />
                          </Fragment>
                        );
                      }
                      if (_item.type === "group") {
                        if (eval(_item?.show)) {
                        return (
                          <Fragment key={_index}>
                            <Group
                              formErr={formErr}
                              clearFieldError={clearFieldError}
                              formFields={_item?.input_fields}
                              handleNext={handleNext}
                              handleCancel={handleCancel}
                              selectedData={selectedData}
                              setSelectedData={setSelectedData}
                            />
                          </Fragment>
                        );
                      }
                      } else {
                        return (
                          <Fragment key={_index}>
                            <DynamicForm
                              formFields={_item}
                              setSelectedData={setSelectedData}
                              selectedData={selectedData}
                              formErr={formErr}
                              clearFieldError={clearFieldError}
                              switchingProfile={switchingProfile}
                              primaryUser={primaryUser}
                            />
                          </Fragment>
                        );
                      }
                    })}
                    <FormButton
                      formButtons={item?.form_buttons}
                      handleNext={validateAndSubmit}
                      handleCancel={handleCancel}
                      selectedData={selectedData}
                      handleBack={handleBack}
                      handleSkip={handleSkip}
                      handleSkipOtp={handleSkipOtp}
                      handleUaePassAuth={handleUaePassAuth}
                    />
                  </Fragment>
                );
              } else handleSkip();
            }
          });
        }
      })}
    </Layout>
  );
};

export default WorkflowVerification;
